/******/ (() => { // webpackBootstrap
class animatedBackgroundTextColors extends HTMLElement {
  constructor() {
    super();

    this.blocks = this.querySelectorAll('[data-announcement-block]');
    this.current = 0; // índice do aviso visível no momento
    this.index = 1;   // próximo aviso que o autoplay vai mostrar
    this.interval;
  }

  connectedCallback() {
    this.init();

    // Arrows de navegação manual (só existem quando há mais de 1 aviso)
    const prevBtn = this.querySelector('[data-announcement-nav="prev"]');
    const nextBtn = this.querySelector('[data-announcement-nav="next"]');
    if (prevBtn) prevBtn.addEventListener('click', () => this.go(this.current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => this.go(this.current + 1));

    // Editor events
    if (window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect.bind(this));
    }
  }

  init() {
    this.interval = setInterval(this.changeColors.bind(this), 7000);
  }

  // Mostra o aviso do índice informado (com wrap) e atualiza cores/estado.
  activate(newIndex) {
    const total = this.blocks.length;
    if (!total) return;
    const target = ((newIndex % total) + total) % total;
    const activeBlock = this.blocks[target];

    // Get colors from the active block
    const backgroundColor = activeBlock.getAttribute('data-background-color-block');
    const frontColor = activeBlock.getAttribute('data-front-color-block');

    // Update component colors with active block colors
    setTimeout(() => {
      this.style.backgroundColor = backgroundColor;
      this.style.color = frontColor;
    }, 350);

    // Remove a classe 'active' do bloco anterior
    const prevActiveBlock = this.querySelector('[data-announcement-block].active');
    if (prevActiveBlock) prevActiveBlock.classList.remove('active');

    // Adiciona 'active' ao novo bloco
    activeBlock.classList.add('active');

    this.current = target;
    this.index = (target + 1) % total;
  }

  changeColors() {
    this.activate(this.index);
  }

  // Navegação manual via arrows: troca o aviso e reinicia o autoplay.
  go(newIndex) {
    clearInterval(this.interval);
    this.activate(newIndex);
    this.init();
  }

  handleBlockSelect(e) {
    const blockIndex = e.target.dataset.announcementBlockIndex;
    if (!blockIndex) return;

    this.blocks.forEach(block => block.classList.remove('active'));

    e.target.classList.add('active');

    this.style.transition = 'none';
    this.style.backgroundColor = e.target.getAttribute('data-background-color-block');
    this.style.color = e.target.getAttribute('data-front-color-block');

    clearInterval(this.interval);
    this.current = parseInt(blockIndex);
    this.index = parseInt(blockIndex);
  }

  handleBlockDeselect(e) {
    const blockIndex = e.target.dataset.announcementBlockIndex;
    if (!blockIndex) return;

    this.style.transition = '';

    // Update index
    this.index = (parseInt(blockIndex) + 1) % this.blocks.length;
    this.init();
  }

}

customElements.define('animated-background-text-colors', animatedBackgroundTextColors);

/******/ })()
;
